import { FilterType } from '@/types/asset-search.types';
import Pill from '@ingka/pill';
import crossIcon from '@ingka/ssr-icon/paths/cross';
import { translate } from '@repo/phrase';
import { Carousel } from '@repo/ui/carousel';

import { useSearch } from '@/components/filters/search/search.hooks';

export const ActiveFilters = () => {
    const { addFilter, removeFilter, removeAllFilters, typeFilter, assetIdFilter, hasFilter } = useSearch();

    const removeTypeFilter = (type: string) => {
        const deleted = typeFilter.filter((filter) => filter !== type);

        if (deleted.length === 0) {
            removeFilter(FilterType.Type);
        } else {
            addFilter(FilterType.Type, deleted.join('_'));
        }
    };

    return (
        <Carousel>
            {assetIdFilter && (
                <Pill
                    size="small"
                    label={translate('asset_search_result', { order: assetIdFilter })}
                    leadingIcon={crossIcon}
                    selected
                    onClick={() => {
                        removeFilter(FilterType.AssetId);
                    }}
                />
            )}
            {typeFilter.map((filter) => (
                <Pill
                    size="small"
                    label={translate(`filter_type_${filter}`)}
                    key={filter}
                    leadingIcon={crossIcon}
                    selected
                    onClick={() => {
                        removeTypeFilter(filter);
                    }}
                />
            ))}
            {hasFilter && <Pill size="small" label={translate('filter_clear_all')} onClick={removeAllFilters} />}
        </Carousel>
    );
};
